import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
    <section className="mt-10 border-t-2 border-ink-200 pt-8">
        <h2 className="font-display text-[28px] font-bold tracking-tight text-ink-800">{title}</h2>
        <div className="mt-5 body-prose space-y-4">{children}</div>
    </section>
);

export default function Privacy() {
    return (
        <main className="min-h-screen bg-limestone-100 pt-32 pb-24" data-testid="privacy-page">
            <div className="asir-stripe h-[6px]" aria-hidden="true" />
            <div className="mx-auto max-w-3xl px-5 pt-10 lg:px-8">
                <p className="eyebrow">Legal · Privacy</p>
                <h1 className="section-headline mt-4" style={{ fontSize: "clamp(36px, 4.4vw, 56px)" }}>Privacy Policy</h1>
                <p className="mt-4 font-mono text-[13px] font-semibold text-ink-600">
                    Last updated: February 2026 · Compliant with PDPL (Personal Data Protection Law, Kingdom of Saudi Arabia).
                </p>

                <Section title="1. Who we are">
                    <p>NourNet (“we”, “our”, “NourNet”) is a SaudiNIC-accredited domain registrar and managed DNS / email provider operating under the Kingdom of Saudi Arabia’s Personal Data Protection Law (PDPL) and overseen by the Communications, Space &amp; Technology Commission (CST).</p>
                </Section>

                <Section title="2. What we collect">
                    <p>We collect only what we need to register domains, deliver DNS &amp; email services, and invoice you:</p>
                    <ul className="list-disc ps-6 space-y-2">
                        <li>Account information — name, email address, phone, organisation.</li>
                        <li>Domain ownership records — required by SaudiNIC and ICANN for Whois registration.</li>
                        <li>Billing data — VAT number, billing address, invoice history. Card numbers are never stored on our servers; payments are processed by Stripe (PCI-DSS Level 1).</li>
                        <li>Usage telemetry — authentication events, DNS zone edits, and failed login attempts — used only to keep the service secure.</li>
                    </ul>
                </Section>

                <Section title="3. Where your data lives">
                    <p>All customer data is stored in Saudi-hosted infrastructure inside the Kingdom. We do not transfer personal data outside of Saudi Arabia without your explicit consent, except where SaudiNIC or ICANN Whois requirements apply.</p>
                </Section>

                <Section title="4. Your rights under PDPL">
                    <p>You have the right to:</p>
                    <ul className="list-disc ps-6 space-y-2">
                        <li>Access the personal data we hold about you.</li>
                        <li>Correct inaccurate or incomplete data.</li>
                        <li>Request deletion (subject to regulatory retention periods).</li>
                        <li>Export your data in a portable format.</li>
                        <li>Withdraw consent for non-essential processing.</li>
                    </ul>
                    <p>To exercise any of these rights, contact us at <a className="text-madder-500 font-semibold" href="mailto:privacy@nournet.sa">privacy@nournet.sa</a>. We respond within 14 days.</p>
                </Section>

                <Section title="5. Cookies &amp; sessions">
                    <p>We set a single encrypted session cookie (<code className="rounded-[4px] bg-mudbrick-200 px-1.5 py-0.5 font-mono text-[14px]">session_token</code>) after you sign in. No advertising, analytics or third-party trackers are used during this preview.</p>
                </Section>

                <Section title="6. Security">
                    <p>All traffic is TLS 1.3 encrypted. Passwords are bcrypt-hashed. Privileged operations are protected by session re-authentication. Our infrastructure undergoes annual penetration testing.</p>
                </Section>

                <Section title="7. Contact">
                    <p>Data Protection Officer · NourNet · Riyadh, KSA<br/>
                    Email: <a className="text-madder-500 font-semibold" href="mailto:dpo@nournet.sa">dpo@nournet.sa</a></p>
                </Section>

                <div className="mt-12 border-t-2 border-ink-200 pt-8">
                    <Link to="/preview" className="inline-flex h-[48px] items-center gap-2 rounded-btn border-2 border-ink-800 bg-white px-5 text-[14px] font-bold text-ink-800 hover:bg-ink-800 hover:text-white">
                        ← Back to NourNet
                    </Link>
                </div>
            </div>
        </main>
    );
}
